var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCwReduceRepetitiveQuestions(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 55,
    height: 55,
    viewBox: "0 0 55 55",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 55,
    height: 55,
    rx: 27.5,
    fill: "#6A097D"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_16848_222)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.975,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M45.9648 18.4727C45.9648 21.8008 45.9648 25.1289 45.9648 28.457C45.3931 29.5029 44.5727 29.749 43.5039 29.1953C43.266 28.9655 43.0903 28.6959 42.9766 28.3867C42.9531 26.4883 42.9297 24.5899 42.9062 22.6914C38.9805 26.6172 35.0547 30.543 31.1289 34.4688C30.5195 34.7969 29.9102 34.7969 29.3008 34.4688C27.1094 32.2773 24.918 30.086 22.7266 27.8945C19.293 31.3281 15.8594 34.7618 12.4258 38.1953C11.357 38.749 10.5367 38.5029 9.96484 37.457C9.96484 37.1289 9.96484 36.8008 9.96484 36.4727C10.0627 36.348 10.1448 36.2074 10.2109 36.0508C14.0898 32.1719 17.9687 28.293 21.8477 24.4141C22.4699 24.0757 23.0792 24.0992 23.6758 24.4844C25.8321 26.6407 27.9883 28.7969 30.1445 30.9531C30.1914 31 30.2383 31 30.2852 30.9531C33.7539 27.4844 37.2227 24.0156 40.6914 20.5469C38.7661 20.5445 36.8443 20.4976 34.9258 20.4063C33.9761 19.925 33.7066 19.1868 34.1172 18.1914C34.3651 17.78 34.7284 17.5339 35.207 17.4531C38.3945 17.4062 41.5821 17.4062 44.7695 17.4531C45.3319 17.6057 45.7304 17.9455 45.9648 18.4727Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_16848_222"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    fill: "white",
    transform: "translate(10 10)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCwReduceRepetitiveQuestions);
export default __webpack_public_path__ + "static/media/cw-reduce-repetitive -questions.7c5f86accfcdf91a8d6cec5ef1910037.svg";
export { ForwardRef as ReactComponent };